import React from "react";
import { Link } from "react-router-dom";

import Api from "../../../lib/componentApi";

class ProfileForm extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  handleLogout = event => {
    event.preventDefault();
    // eslint-disable-next-line
    if (__isBrowser__) {
      localStorage.removeItem("deliveryDetails");
      Api.get("/api/logout", {}, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "code-logout");
        } else {
          window.location.href = "/";
        }
      });
    }
  };
  render() {
    const { user, onClickSection, unReadNews } = this.props;
    const { email, firstName, lastName, mobileNumber, points } = user || "";
    return (
      user &&
      user.uid && (
        <div className="profile-page bg-white visible-xs">
          <div className="header-dark">
            <div className="avatar d-flex align-items-center">
              <h4>
                {firstName} {lastName}
              </h4>
            </div>

            <p>{email}</p>
            <p>{mobileNumber}</p>
            <div className="d-flex justify-content-between align-items-center">
              <Link
                to="/profile?edit"
                onClick={() => onClickSection("editSection")}
                className="d-flex align-items-center"
              >
                <i className="icon icon-edit" /> <span>Edit Profile</span>
              </Link>
              <span className="beta-user">BETA USER</span>
            </div>
          </div>
          <div className="blue-points">
            <div>
              <Link
                to="/profile?rewards"
                onClick={() => onClickSection("rewardsSection")}
              >
                <p>You have</p>
                <p>
                  <span>{points} eCoins</span>
                </p>
              </Link>
            </div>
          </div>
          <div className="profile-link">
            <ul>
              <li>
                <Link
                  to="/profile?orders"
                  onClick={() => onClickSection("ordersSection")}
                >
                  Your Orders
                </Link>
              </li>
              <li>
                <Link
                  to="/profile?news"
                  onClick={() => onClickSection("newsSection")}
                >
                  What{"'"}s New?
                  {(unReadNews && <span>{unReadNews}</span>) || <noscript />}
                </Link>
              </li>
              <li>
                <Link
                  to="/profile?addresses"
                  onClick={() => onClickSection("addressSection")}
                >
                  Your Addresses
                </Link>
              </li>
              <li>
                <Link
                  to="/profile?favorites"
                  onClick={() => onClickSection("favoritesSection")}
                >
                  Your Favorites
                </Link>
              </li>
              <li>
                <Link
                  to="/profile?payments"
                  onClick={() => onClickSection("paymentSection")}
                >
                  Payment Methods
                </Link>
              </li>

              <li>
                <Link
                  to="/profile?addresses"
                  onClick={() => onClickSection("addressSection")}
                >
                  Your Addresses
                </Link>
              </li>
              <li>
                <Link
                  to="/profile?promotions"
                  onClick={() => onClickSection("promotionsSection")}
                >
                  Promotions
                </Link>
              </li>
              {/* Settings Page */}
              <li>
                <Link
                  to="/profile?settings"
                  onClick={() => onClickSection("settingsSection")}
                >
                  Settings
                </Link>
              </li>
              <li>
                <a onClick={this.handleLogout} href="javascript: void(0)">
                  Log out
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    );
  }
}

export default ProfileForm;
